import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { COLUMN_LABELS } from './browseInventoryColumns';
import { homeTypeLabel } from '../../helpers/homeClassification';

const shown = value => value === null || value === undefined || value === '' ? '—' : value;

export default function InventoryBrowseCards({ rows, visibleColumns, renderCell, excludedIds, onIncludeChange, onEdit, onFiles, onCopy, onDuplicate }) {
  if (!rows.length) return <p className="inventory-empty" role="status">No homes match these filters. Try changing the filters or search.</p>;
  return <div className="inventory-card-grid">
    {rows.map(unit => {
      const title = unit.model?.modelName || unit.model?.modelNumber || unit.serialA || 'Inventory unit';
      return <article className="inventory-unit-card" key={unit._id} aria-label={title}>
        <div className="inventory-unit-status">
          <Badge variant="light">{unit.inventoryStatus || 'Status unavailable'}</Badge>
          {!!unit.curtailmentYears && renderCell('curtailment', unit)}
        </div>
        <div className="inventory-unit-heading">
          <span className="inventory-unit-maker">{unit.manufacturer?.factoryShortName || 'Manufacturer unavailable'}</span>
          <h2>{title}</h2>
          {unit.model?.modelNumber && unit.model.modelNumber !== title && <span className="inventory-unit-number">Model {unit.model.modelNumber}</span>}
          <p>{unit.unitLocation?.location || 'Location unavailable'}{unit.slotNumber ? ' · Slot ' + unit.slotNumber : ''}</p>
        </div>
        <div className="inventory-unit-specs">
          <span>{shown(unit.bedRooms)} beds</span><span>{shown(unit.bathRooms)} baths</span><span>{shown(unit.sizeOverall)}</span>
        </div>
        <div className={'inventory-unit-type' + (unit.homeTypeNeedsReview ? ' text-danger' : '')}>{homeTypeLabel(unit)}</div>
        {visibleColumns.includes('maxSalesPrice') && <div className="inventory-unit-price"><span>Max sales price</span><div>{renderCell('maxSalesPrice', unit)}</div></div>}
        <div className="inventory-unit-actions">
          <Button variant="primary" onClick={() => onEdit(unit)}>Edit</Button>
          <Button variant="outline-secondary" onClick={() => onFiles(unit)}>Files</Button>
          <Button variant="outline-secondary" onClick={() => onCopy(unit)}>Copy</Button>
        </div>
        <details className="inventory-unit-details">
          <summary>Details &amp; report selection</summary>
          <label className="inventory-unit-include"><input type="checkbox" checked={!excludedIds.includes(unit._id)} onChange={event => onIncludeChange(unit._id, event.target.checked)}/> Include this home in reports</label>
          <dl>{visibleColumns.filter(key => !['inventoryStatus', 'maxSalesPrice', 'curtailment'].includes(key)).map(key => <div key={key}><dt>{COLUMN_LABELS[key]}</dt><dd>{renderCell(key, unit) || '—'}</dd></div>)}</dl>
          <Button variant="outline-secondary" onClick={() => onDuplicate(unit)}>Duplicate unit</Button>
        </details>
      </article>;
    })}
  </div>;
}
